export default __webpack_public_path__ + "static/media/chicagoMinia.eeeb2e84.png";